module.exports = __webpack_public_path__ + "img/facebook-post.89b8fecf.png";